/** @format */

export enum ACTION_TYPES {
	SET_DISPUTE_READINESS = 'SET_DISPUTE_READINESS',
	SET_ERROR_FOR_DISPUTE_READINESS = 'SET_ERROR_FOR_DISPUTE_READINESS',
}
